import { TimezoneModel } from "../models/TimezoneModel";

export function findClosestTimezone(dataset: TimezoneModel[], browserTz: string) {
  // 1. Exact match first
  const exact = dataset.find(tz => tz.id === browserTz);
  if (exact) return exact;

  // 2. Otherwise, get browser offset
  const offsetMinutes = new Date().getTimezoneOffset(); // e.g., -600 for +10:00
  const offsetHours = -(offsetMinutes / 60);

  const parseOffset = (offsetStr: string) => {
    const [h, m] = offsetStr.split(":").map(Number);
    return h + (m / 60);
  };

  // 3. Detect if browser timezone currently uses DST
  const jan = new Date(new Date().getFullYear(), 0, 1).getTimezoneOffset();
  const jul = new Date(new Date().getFullYear(), 6, 1).getTimezoneOffset();
  const browserUsesDST = jan !== jul;

  // 4. Match by offset AND DST support
  const byOffsetAndDst = dataset.find(
    tz => parseOffset(tz.baseUtcOffset) === offsetHours &&
          tz.supportsDaylightSavingTime === browserUsesDST
  );

  if (byOffsetAndDst) return byOffsetAndDst;

  // 5. Fallback: just offset
  const byOffset = dataset.find(tz => parseOffset(tz.baseUtcOffset) === offsetHours);
  if (byOffset) return byOffset;

  return null;
}
